// Debounced SAS parser integration for CodeMirror 6's @codemirror/lint.
// On document change the editor calls kolilang_parse on the full document
// (300 ms debounce) and renders diagnostics as squigglies. Results are
// routed through main.ts's shared cache so the status-bar updater doesn't
// re-parse the same document.

import { linter, Diagnostic as CmDiagnostic } from '@codemirror/lint';
import { EditorView } from '@codemirror/view';
import { ensureParse } from './parse-cache';
import type { Kolilang } from './wasm';

export function sasLinter(_kolilang: Kolilang) {
  return linter(
    (view: EditorView): CmDiagnostic[] => {
      const doc = view.state.doc.toString();
      try {
        const result = ensureParse(doc);
        return result.diagnostics.map((d) => ({
          from: Math.min(d.s, doc.length),
          to: Math.min(Math.max(d.e, d.s + 1), doc.length),
          severity: d.sev,
          message: d.msg,
        }));
      } catch (e) {
        return [
          {
            from: 0,
            to: Math.min(1, doc.length),
            severity: 'error',
            message: `kolilang: ${e instanceof Error ? e.message : String(e)}`,
          },
        ];
      }
    },
    { delay: 300 }
  );
}
